<template>
  <div class="colorDominant" style="border-radius: 6px 6px 0 0">
    <v-card class="colorDominant pb-4">
      <v-tabs
        v-model="tab"
        center-active
        show-arrows
        background-color="colorDominant colorTabs"
      >
        <v-tab
          style="width: 33.3%"
          v-for="tab in tabs"
          :key="tab.routeName"
          @click="tabChanged(tab.routeName)"
        >
          {{ tab.nameBtn }}
        </v-tab>
      </v-tabs>
      <div>
        <router-view></router-view>
      </div>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "SuspendAccount",
  data: () => ({
    document: "",
    date_start: "",
    date_final: "",
    tab: 0,
  }),
  computed: {
    tabs() {
      return [
        {
          routeName: 'responsibleGamingDoc',
          nameBtn: this.$t("responsibleGaming"),
        },
        {
          routeName: 'accountSuspend',
          nameBtn: this.$t("accountSuspend"),
        },
        {
          routeName: 'autoExclude',
          nameBtn: this.$t("autoExclude"),
        },
      ];
    },
  },
  mounted() {
    this.$router.push({
      name: 'responsibleGamingDoc',
      query: {
        component: "responsibleGaming",
      },
    });
  },
  methods: {
    tabChanged(routeName) {
      if (this.$route.name !== routeName) {
        this.$router.push({
          name: routeName,
          query: {
            component: "responsibleGaming",
          },
        });
      }
    },
  },
};
</script>
